import React, { Component } from "react";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import ResetToDefaultProps from "editor/components/ResetToDefaultProps";
import ColorPicker from "./ColorPickerComponent";
import { PropListItem } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
  > div {
    width: 100%;
  }
`;

class Color extends Component {
  constructor(props) {
    super(props);
    this.state = {
      color: props.currentValue || { r: 255, g: 255, b: 255, a: 1 },
    };
  }

  handleChange = (colorProps) => {
    const { updaterFn, name } = this.props;
    this.setState({ color: colorProps.rgb });

    updaterFn({ prop: name, value: colorProps.rgb });
  };

  render() {
    const {
      currentValue,
      label,
      locale,
      tooltip,
      name,
      defaultValue,
      updaterFn,
    } = this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;
    const { color } = this.state;

    console.log(defaultValue);

    return (
      <CustomPropListItem>
        <ColorPicker
          color={!color ? currentValue : color}
          onChange={this.handleChange}
          label={
            <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
          }
          resetProps={
            <ResetToDefaultProps
              name={name}
              defaultProps={defaultValue}
              updaterFn={updaterFn}
            />
          }
        />
      </CustomPropListItem>
    );
  }
}

export default Color;
